import React from 'react';
import { compose } from 'ramda';
import { SlideContext } from './slideContext';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './SlideItem.js';


const SlideItem = class SlideItem extends React.Component {
  static contextType = SlideContext;
  static displayName = "SlideItem";

  constructor(props) {
    super(props);
  }

  componentDidMount () {
    const { theme, config } = this.props;
    const { className } = config;
    const { classes } = theme.styles;
    
    this.context.subscribeSlide(
      <div className={[className,classes.slideItem].join(' ')} >
        {this.props.children}
      </div>
    );
    
  }

  render() {
    return null;
  }
}


export default compose(
  PropertyManager([
    'children',
    'onClick',
    'className'
  ]),
  withThemeJSS({ styleFile, displayName: 'SlideItem' })
)(SlideItem);